import removeItemFromCart from './remove-item-from-cart';

type MoveToFavoritesProps = {
    item: CartItem;
    itemIndex?: number;
    changeFavorite: (material: Material, add: boolean) => void;
    removeFromCart: (materialId: number) => void;
};

const moveToFavorites = ({ item, itemIndex, changeFavorite, removeFromCart }: MoveToFavoritesProps): void => {
    changeFavorite(item.material, true);

    removeItemFromCart({ item, itemIndex, removeFromCart });
};

export default moveToFavorites;
